import { getIsOverseas } from '@/utils/site-region';

export const DISPLAY_FEATURES_DEVELOPING = true;

export const ENABLE_EXPRESS_MODE = true;

export const isCN = (() => {
    const mock = localStorage.getItem('mock_cn_deploy_flag');

    if(mock === 'true') {
        return true;
    } else if(mock === 'false') {
        return false;
    }

    return !getIsOverseas();
})();
